import { render, staticRenderFns } from "./poa-upload-button.vue?vue&type=template&id=19ee44c2&"
import script from "./poa-upload-button.vue?vue&type=script&lang=js&"
export * from "./poa-upload-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ee44c2')) {
      api.createRecord('19ee44c2', component.options)
    } else {
      api.reload('19ee44c2', component.options)
    }
    module.hot.accept("./poa-upload-button.vue?vue&type=template&id=19ee44c2&", function () {
      api.rerender('19ee44c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/poa-upload-button.vue"
export default component.exports